import * as types from '../constants/StoriesActionTypes'
import fetch from 'isomorphic-fetch'
import {__PREFIX__} from '../constants/UrlPrefix'
import {env} from '../constants/Environment';

export function fetch_stories(startAt) {
	return async function(dispatch, getState){
        const firestore = getState().config.firestore;
        const limit = 50;

        console.log(startAt);

		dispatch(request_stories());
		
        let docs = null;
        try {
            let q = firestore.collection('environments/' + env + '/stories').where('deleted', '!=', true).orderBy('deleted').orderBy('draft.modified', 'desc');

            if(typeof startAt !== 'undefined' && startAt !== null)
                q = q.startAt(false, startAt);

            q = q.limit(limit + 1);
            docs = await q.get();
        }catch(e){
            console.log(e);
        }
        
        let stories = {};
        let next = null;

        if(docs !== null){
            docs.forEach((contentDoc) => {
                let d = contentDoc.data();

                if(Object.keys(stories).length == limit)
                    next = d;
                else
                    stories[contentDoc.id] = {id: contentDoc.id, ...d};
            });
        }
        
        dispatch(receive_stories(stories, next));
	}
}

export function request_stories() {  
  return {
    type: types.REQUEST_STORIES
  };
}

export function receive_stories(stories, next){
	return  {
		type: types.RECEIVE_STORIES,
        stories: stories,
        next: next
	}
}

export function select(storyId, draftId){
    return async function(dispatch, getState){
        const firestore = getState().config.firestore;
        dispatch(request_story(storyId));
                
        let doc = null;
        try {
            doc = await firestore.collection('environments/' + env + '/stories/' + storyId + '/versions').doc(draftId).get();
        }catch(e){
            console.log(e);
        }

        let docs = null;
        try {
            docs = await firestore.collection('environments/' + env + '/stories/' + storyId + '/versions/' + draftId + '/content').get();
        }catch(e){
            console.log(e);
        }
        
        let contents = [];

        if(docs !== null){
            docs.forEach((contentDoc) => {
                let d = contentDoc.data();
                contents.push({...d, version_saved: d.version});
            });

            contents.sort((a, b) => a.idx - b.idx);
        }

        if(doc !== null && doc.exists){
            let d = doc.data();
			dispatch(receive_story(storyId, {...d, draft_id: draftId, version_saved: d.version, content: contents}));
        }else{
            dispatch(receive_story(storyId, {}));
        }
	}
}

export function request_story(storyId){
    return {
        type: types.REQUEST_STORY,
        id: storyId
    }
}

export function receive_story(storyId, data){
    return {
        type: types.RECEIVE_STORY,
        id: storyId,
        data: data
    }
}

export function update_settings(key, value){
    return {
        type: types.UPDATE_SETTINGS,
        key: key,
        value: value
    }
}

export function update_content(key, content){
    return {
        type: types.UPDATE_CONTENT,
        key: key,
        value: content
    }
}

export function save_draft(storyId, draftId, version, settings){
    return async function(dispatch, getState){
        const firestore = getState().config.firestore;
        const uid = getState().firebase.auth.uid;

		dispatch(request_save(storyId, version));
        
        let result = null;
        try {
            result = await firestore.collection('environments/' + env + '/stories/' + storyId + '/versions').doc(draftId).set({
                id: storyId,
                draft_id: draftId,
                uid: uid,
                version: version,
                settings: settings
            });
        }catch(e){
            console.log(e);
        }
        
        if(result !== null){
			dispatch(receive_save(storyId, version, true));
        }else{
            dispatch(receive_save(storyId, version, false));
        }
	}
}

export function request_save(storyId, v){
    return {
        type: types.REQUEST_SAVING, 
        version: v,
        id: storyId
    }
}

export function receive_save(storyId, v, success){
    return {
        type: types.RECEIVE_SAVING,
        id: storyId,
        version: v,
        success: success
    }
}

export function save_content(storyId, draftId, key, version, value){
    return async function(dispatch, getState){
        const firestore = getState().config.firestore;
        const uid = getState().firebase.auth.uid;

		dispatch(request_content_save(storyId, key, version));
        
        let result = null;
        try {
            result = await firestore.collection('environments/' + env + '/stories/' + storyId + '/versions/' + draftId + '/content').doc(String(key)).set({
                idx: key,
                uid: uid,
                version: version,
                ...value
            });
        }catch(e){
            console.log(e);
        }
        
        if(result !== null){
			dispatch(receive_content_save(storyId, key, version, true));
        }else{
            dispatch(receive_content_save(storyId, key, version, false));
        }
	}
}

export function request_content_save(storyId, idx, v){
    return {
        type: types.REQUEST_CONTENT_SAVING,
        id: storyId,
        version: v,
        idx: idx
    }
}

export function receive_content_save(storyId, idx, v, success){
    return {
        type: types.RECEIVE_CONTENT_SAVING,
        id: storyId,
        version: v,
        idx: idx,
        success: success
    }
}

export function publish(storyId, draftId){
    return async function(dispatch, getState){
        const firestore = getState().config.firestore;
        const uid = getState().firebase.auth.uid;

		dispatch(request_publishing(storyId, draftId));
        
        let result = null;
        try {
            result = await firestore.collection('environments/' + env + '/stories/' + storyId + '/versions').doc(draftId).set({
                published: {
                    on: new Date(),
                    uid: uid
                }
            }, {
                merge: true
            });
        }catch(e){
            console.log(e);
        }
        
        if(result !== null){
			dispatch(receive_publishing(storyId, draftId, true));
        }else{
            dispatch(receive_publishing(storyId, draftId, false));
        }
	}
}

export function request_publishing(storyId, v){
    return {
        type: types.REQUEST_PUBLISHING, 
        draft_id: v,
        id: storyId
    }
}

export function receive_publishing(storyId, v, success){
    return {
        type: types.RECEIVE_PUBLISHING,
        id: storyId,
        draft_id: v,
        success: success
    }
}

export function trigger_push(storyId, draftId){
    return async function(dispatch, getState){
        const firestore = getState().config.firestore;
        const uid = getState().firebase.auth.uid;

		dispatch(request_trigger_push(storyId, draftId));
        
        let t = new Date();
        let result = null;
        try {
            result = await firestore.collection('environments/' + env + '/stories/' + storyId + '/versions').doc(draftId).set({
                notification_trigger: {
                    on: t,
                    uid: uid
                }
            }, {
                merge: true
            });
        }catch(e){
            console.log(e);
        }
        
        if(result !== null){
			dispatch(receive_trigger_push(storyId, draftId, true, t));
        }else{
            dispatch(receive_trigger_push(storyId, draftId, false, t));
        }
	}
}

export function request_trigger_push(storyId, v){
    return {
        type: types.REQUEST_TRIGGER_PUSH, 
        draft_id: v,
        id: storyId
    }
}

export function receive_trigger_push(storyId, v, success, t){
    return {
        type: types.RECEIVE_TRIGGER_PUSH,
        id: storyId,
        draft_id: v,
        success: success,
        triggeredOn: t
    }
}

export function create_draft(storyId, draftId){
    return {
        type: types.CREATE_DRAFT,
        id: storyId,
        draft_id: draftId
    }
}

export function remove(storyId, draftId){
    return async function(dispatch, getState){
        const firestore = getState().config.firestore;
        const uid = getState().firebase.auth.uid;

		dispatch(request_delete(storyId, draftId));
        
        let result = null;
        try {
            result = await firestore.collection('environments/' + env + '/stories/' + storyId + '/versions').doc(draftId).set({
                deleted: {
                    on: new Date(),
                    uid: uid
                }
            }, {
                merge: true
            });
        }catch(e){
            console.log(e);
        }
        
        if(result !== null){
			dispatch(receive_delete(storyId, draftId, true));
        }else{
            dispatch(receive_delete(storyId, draftId, false));
        }
	}
}

export function request_delete(storyId, v){
    return {
        type: types.REQUEST_DELETING, 
        draft_id: v,
        id: storyId
    }
}

export function receive_delete(storyId, v, success){
    return {
        type: types.RECEIVE_DELETING,
        id: storyId,
        draft_id: v,
        success: success
    }
}